// src/components/homepage/HomePageCustomCta.tsx

import React from 'react';
import { motion } from 'framer-motion';
import { Wrench, MessageCircle } from 'lucide-react';
import {Button} from '@dopomogai/ui';

interface CustomCtaData {
  headline: string;
  intro: string;
  cta1_text: string;
  cta1_ariaLabel: string;
  cta2_text: string;
  cta2_ariaLabel: string;
}

interface HomePageCustomCtaProps {
  customCtaData: CustomCtaData;
  onAction: (actionType: string, payload?: any) => void;
  id?: string;
}

export const HomePageCustomCta: React.FC<HomePageCustomCtaProps> = ({ customCtaData, onAction, id }) => {
  return (
    <section id={id} className="py-16 md:py-20">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 30, scale: 0.95 }}
          whileInView={{ opacity: 1, y: 0, scale: 1 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6, ease: 'easeOut' }}
          className="bg-gradient-to-br from-slate-800 to-gray-900 text-white p-8 md:p-12 rounded-2xl border-2 border-black text-center"
        >
          <div className="inline-flex items-center justify-center p-3 bg-white/10 rounded-lg border border-white/20 mb-5">
            <Wrench size={32} className="text-white" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold">
            {customCtaData.headline}
          </h2>
          <p className="mt-4 max-w-3xl mx-auto text-slate-300 text-lg">
            {customCtaData.intro}
          </p>
          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
            <Button
              text={customCtaData.cta1_text}
              ariaLabel={customCtaData.cta1_ariaLabel}
              variant="primary"
              size="lg"
              icon={<MessageCircle size={18} />}
              onClick={() => onAction('OPEN_CONTACT_MODAL', { type: 'audit', subject: 'Architecture Audit Request' })}
              // CORRECTED: Use a light-colored shadow on hover for dark backgrounds
className="hover:shadow-[4px_4px_0_0_#6ee7b7]" // slate-200
            />
            <Button
              text={customCtaData.cta2_text}
              ariaLabel={customCtaData.cta2_ariaLabel}
              variant="secondary"
              size="lg"
              onClick={() => onAction('NAVIGATE_TO_PAGE', { path: '/solutions/custom' })}
              // CORRECTED: Use a light-colored shadow on hover for dark backgrounds
              className="bg-slate-200 text-slate-800 hover:bg-white hover:shadow-[4px_4px_0_0_#94a3b8]" // slate-400
            />
          </div>
        </motion.div>
      </div>
    </section>
  );
};

